document.addEventListener("DOMContentLoaded", () => {

  /*
   * Custom Chics Phone Model Selector
   *
   * Runs only on Premium PrintShield phone cases.
   *
   * Flow:
   * Brand → Phone Model
   */


  /* ---------------------------------------------------------
     BASIC CHECKS
  --------------------------------------------------------- */

  if (!window.isPhoneCase) return;

  if (
    !window.phoneFrames ||
    typeof window.phoneFrames !== "object"
  ) {

    console.warn(
      "Custom Chics: phoneFrames not available."
    );

    return;

  }


  const form = document.querySelector(
    'form[data-type="add-to-cart-form"]'
  );


  if (!form) {

    console.warn(
      "Custom Chics: Product form not found."
    );

    return;

  }


  /* ---------------------------------------------------------
     HELPERS
  --------------------------------------------------------- */

  function normalizeModel(value) {

    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-");

  }


  function prettyModel(key) {

    if (!key) return "";

    return key
      .replace(/-/g, " ")
      .replace(/\b\w/g, char => char.toUpperCase());

  }


  function getBrand(modelKey) {

    const key = normalizeModel(modelKey);


    if (
      key.startsWith("iphone-") ||
      key.startsWith("ipad-")
    ) {
      return "Apple";
    }


    if (
      key.startsWith("samsung-") ||
      key.startsWith("galaxy-")
    ) {
      return "Samsung";
    }


    if (
      key.startsWith("oneplus-") ||
      key.startsWith("one-plus-")
    ) {
      return "OnePlus";
    }


    if (
      key.startsWith("pixel-") ||
      key.startsWith("google-")
    ) {
      return "Google";
    }


    if (key.startsWith("nothing-")) {
      return "Nothing";
    }


    if (
      key.startsWith("motorola-") ||
      key.startsWith("moto-")
    ) {
      return "Motorola";
    }


    if (
      key.startsWith("xiaomi-") ||
      key.startsWith("redmi-") ||
      key.startsWith("mi-")
    ) {
      return "Xiaomi";
    }


    if (key.startsWith("poco-")) {
      return "POCO";
    }


    if (key.startsWith("realme-")) {
      return "Realme";
    }


    if (key.startsWith("oppo-")) {
      return "OPPO";
    }


    if (key.startsWith("vivo-")) {
      return "Vivo";
    }


    if (key.startsWith("iqoo-")) {
      return "iQOO";
    }


    if (key.startsWith("infinix-")) {
      return "Infinix";
    }


    if (key.startsWith("tecno-")) {
      return "Tecno";
    }


    if (key.startsWith("asus-")) {
      return "ASUS";
    }


    if (key.startsWith("sony-")) {
      return "Sony";
    }


    if (key.startsWith("honor-")) {
      return "HONOR";
    }


    return "Other";

  }


  /* ---------------------------------------------------------
     OUT OF STOCK MODELS
     
     Managed separately in phone-stock.js
  --------------------------------------------------------- */

  const outOfStockModels =
    Array.isArray(window.phoneOutOfStock)
      ? window.phoneOutOfStock.map(normalizeModel)
      : [];


  /* ---------------------------------------------------------
     MODEL DATABASE
  --------------------------------------------------------- */

  const models = Object.keys(window.phoneFrames)

    .filter(key => window.phoneFrames[key])

    .map(key => ({
      key: normalizeModel(key),
      name: prettyModel(key),
      brand: getBrand(key)
    }));


  if (!models.length) {

    console.warn(
      "Custom Chics: No phone models found."
    );

    return;

  }


  /* ---------------------------------------------------------
     BRAND DATABASE
  --------------------------------------------------------- */

  const brands = [
    ...new Set(
      models.map(model => model.brand)
    )
  ].sort((a, b) => {

    if (a === "Other") return 1;
    if (b === "Other") return -1;

    return a.localeCompare(b);

  });


  /* ---------------------------------------------------------
     BUILD SELECTOR
  --------------------------------------------------------- */

  const wrapper = document.createElement("div");

  wrapper.className =
    "cc-phone-selector";


  wrapper.innerHTML = `

    <!-- BRAND SELECTOR -->

    <div class="cc-phone-selector__group">

      <label class="cc-phone-selector__label">

        Brand <span>*</span>

      </label>


      <button
        type="button"
        class="cc-phone-selector__button cc-phone-selector__brand-button"
        aria-expanded="false"
      >

        <span class="cc-phone-selector__value cc-phone-selector__brand-value">

          Select Brand

        </span>


        <span class="cc-phone-selector__arrow">

          ▾

        </span>

      </button>


      <div
        class="cc-phone-selector__dropdown cc-phone-selector__brand-dropdown"
        hidden
      >

        <input
          type="search"
          class="cc-phone-selector__search cc-phone-selector__brand-search"
          placeholder="Search brand..."
          autocomplete="off"
        >


        <div
          class="cc-phone-selector__list cc-phone-selector__brand-list"
        ></div>

      </div>

    </div>


    <!-- MODEL SELECTOR -->

    <div
      class="cc-phone-selector__group cc-phone-selector__model-group"
      hidden
    >

      <label class="cc-phone-selector__label">

        Phone Model <span>*</span>

      </label>


      <button
        type="button"
        class="cc-phone-selector__button cc-phone-selector__model-button"
        aria-expanded="false"
      >

        <span class="cc-phone-selector__value cc-phone-selector__model-value">

          Select Phone Model

        </span>


        <span class="cc-phone-selector__arrow">

          ▾

        </span>

      </button>


      <div
        class="cc-phone-selector__dropdown cc-phone-selector__model-dropdown"
        hidden
      >

        <input
          type="search"
          class="cc-phone-selector__search cc-phone-selector__model-search"
          placeholder="Search phone model..."
          autocomplete="off"
        >


        <div
          class="cc-phone-selector__list cc-phone-selector__model-list"
        ></div>

      </div>

    </div>


    <!-- VALIDATION ERROR -->

    <div
      class="cc-phone-selector__error"
      hidden
    >

      Please select your phone model.

    </div>

  `;


  const buttons =
    form.querySelector(
      ".product-form__buttons"
    );


  if (buttons) {

    buttons.parentNode.insertBefore(
      wrapper,
      buttons
    );

  } else {

    form.prepend(wrapper);

  }


  /* ---------------------------------------------------------
     ELEMENT REFERENCES
  --------------------------------------------------------- */

  const brandButton =
    wrapper.querySelector(
      ".cc-phone-selector__brand-button"
    );


  const brandValue =
    wrapper.querySelector(
      ".cc-phone-selector__brand-value"
    );


  const brandDropdown =
    wrapper.querySelector(
      ".cc-phone-selector__brand-dropdown"
    );


  const brandSearch =
    wrapper.querySelector(
      ".cc-phone-selector__brand-search"
    );


  const brandList =
    wrapper.querySelector(
      ".cc-phone-selector__brand-list"
    );


  const modelGroup =
    wrapper.querySelector(
      ".cc-phone-selector__model-group"
    );


  const modelButton =
    wrapper.querySelector(
      ".cc-phone-selector__model-button"
    );


  const modelValue =
    wrapper.querySelector(
      ".cc-phone-selector__model-value"
    );


  const modelDropdown =
    wrapper.querySelector(
      ".cc-phone-selector__model-dropdown"
    );


  const modelSearch =
    wrapper.querySelector(
      ".cc-phone-selector__model-search"
    );


  const modelList =
    wrapper.querySelector(
      ".cc-phone-selector__model-list"
    );


  const error =
    wrapper.querySelector(
      ".cc-phone-selector__error"
    );


  /* ---------------------------------------------------------
     SHOPIFY LINE ITEM PROPERTY
  --------------------------------------------------------- */

  let propertyInput =
    form.querySelector(
      'input[name="properties[Phone Model]"]'
    );


  if (!propertyInput) {

    propertyInput =
      document.createElement("input");

    propertyInput.type =
      "hidden";

    propertyInput.name =
      "properties[Phone Model]";

    propertyInput.value =
      "";

    form.appendChild(
      propertyInput
    );

  }


  /* ---------------------------------------------------------
     PREVIEW BRIDGE
     
     Existing custom-chics-preview.js detects this
     hidden radio input.
  --------------------------------------------------------- */

  let previewBridge =
    form.querySelector(
      "#cc-phone-model-preview"
    );


  if (!previewBridge) {

    previewBridge =
      document.createElement("input");

    previewBridge.type =
      "radio";

    previewBridge.id =
      "cc-phone-model-preview";

    previewBridge.name =
      "cc-phone-model-preview";

    previewBridge.setAttribute(
      "data-type",
      "dropdown"
    );

    previewBridge.style.display =
      "none";

    previewBridge.disabled =
      false;

    form.appendChild(
      previewBridge
    );

  }


  /* ---------------------------------------------------------
     CURRENT SELECTION
  --------------------------------------------------------- */

  let selectedBrand = null;

  let selectedModel = null;


  /* ---------------------------------------------------------
     CLOSE ALL DROPDOWNS
  --------------------------------------------------------- */

  function closeDropdowns() {

    brandDropdown.hidden =
      true;

    modelDropdown.hidden =
      true;


    brandButton.setAttribute(
      "aria-expanded",
      "false"
    );


    modelButton.setAttribute(
      "aria-expanded",
      "false"
    );

  }


  /* ---------------------------------------------------------
     RENDER BRANDS
  --------------------------------------------------------- */

  function renderBrands(searchTerm = "") {

    const query =
      searchTerm
        .trim()
        .toLowerCase();


    brandList.innerHTML =
      "";


    const filtered =
      brands.filter(brand => {

        if (!query) return true;

        return brand
          .toLowerCase()
          .includes(query);

      });


    if (!filtered.length) {

      const empty =
        document.createElement("div");

      empty.className =
        "cc-phone-selector__empty";

      empty.textContent =
        "No brand found.";

      brandList.appendChild(
        empty
      );

      return;

    }


    filtered.forEach(brand => {

      const item =
        document.createElement("button");


      item.type =
        "button";


      item.className =
        "cc-phone-selector__item";


      item.innerHTML = `

        <span class="cc-phone-selector__item-name">

          ${brand}

        </span>

      `;


      item.addEventListener(
        "click",
        () => {

          selectBrand(
            brand
          );

        }
      );


      brandList.appendChild(
        item
      );

    });

  }


  /* ---------------------------------------------------------
     RENDER MODELS FOR SELECTED BRAND
  --------------------------------------------------------- */

  function renderModels(searchTerm = "") {

    const query =
      searchTerm
        .trim()
        .toLowerCase();


    modelList.innerHTML =
      "";


    const filtered =
      models.filter(model => {

        if (
          model.brand !==
          selectedBrand
        ) {
          return false;
        }


        if (!query) return true;


        return model.name
          .toLowerCase()
          .includes(query);

      });


    if (!filtered.length) {

      const empty =
        document.createElement("div");

      empty.className =
        "cc-phone-selector__empty";

      empty.textContent =
        "No phone model found.";

      modelList.appendChild(
        empty
      );

      return;

    }


    filtered.forEach(model => {

      const isOutOfStock =
        outOfStockModels.includes(
          model.key
        );


      const item =
        document.createElement("button");


      item.type =
        "button";


      item.className =
        "cc-phone-selector__item";


      item.dataset.model =
        model.key;


      if (isOutOfStock) {

        item.classList.add(
          "cc-phone-selector__item--oos"
        );

        item.disabled =
          true;

      }


      item.innerHTML = `

        <span class="cc-phone-selector__item-name">

          ${model.name}

        </span>


        <span class="cc-phone-selector__item-brand">

          ${
            isOutOfStock
              ? "Out of Stock"
              : ""
          }

        </span>

      `;


      if (!isOutOfStock) {

        item.addEventListener(
          "click",
          () => {

            selectModel(
              model.key
            );

          }
        );

      }


      modelList.appendChild(
        item
      );

    });

  }


  /* ---------------------------------------------------------
     SELECT BRAND
  --------------------------------------------------------- */

  function selectBrand(brand) {

    selectedBrand =
      brand;


    selectedModel =
      null;


    /*
     * Brand display.
     */

    brandValue.textContent =
      brand;


    /*
     * Reset model selector.
     */

    modelValue.textContent =
      "Select Phone Model";


    propertyInput.value =
      "";


    /*
     * Reset preview bridge.
     */

    previewBridge.value =
      "";

    previewBridge.checked =
      false;


    /*
     * Remove old model from session storage.
     */

    sessionStorage.removeItem(
      "cc_phone_model"
    );


    /*
     * Remove validation error.
     */

    error.hidden =
      true;


    /*
     * Show model selector.
     */

    modelGroup.hidden =
      false;


    /*
     * Close brand dropdown.
     */

    brandDropdown.hidden =
      true;


    brandButton.setAttribute(
      "aria-expanded",
      "false"
    );


    /*
     * Prepare model list.
     */

    modelSearch.value =
      "";

    renderModels();


    /*
     * Open model selector automatically.
     */

    modelDropdown.hidden =
      false;


    modelButton.setAttribute(
      "aria-expanded",
      "true"
    );


    setTimeout(() => {

      modelSearch.focus();

    }, 50);

  }


  /* ---------------------------------------------------------
     SELECT MODEL
  --------------------------------------------------------- */

  function selectModel(modelKey) {

    const normalizedKey =
      normalizeModel(
        modelKey
      );


    if (
      !Object.prototype.hasOwnProperty.call(
        window.phoneFrames,
        normalizedKey
      )
    ) {

      return;

    }


    /*
     * Never allow an out-of-stock
     * model to be selected.
     */

    if (
      outOfStockModels.includes(
        normalizedKey
      )
    ) {

      return;

    }


    const model =
      models.find(
        item =>
          item.key ===
          normalizedKey
      );


    if (!model) return;


    selectedBrand =
      model.brand;


    selectedModel =
      normalizedKey;


    const readableName =
      prettyModel(
        normalizedKey
      );


    /*
     * Save selected model.
     */

    sessionStorage.setItem(
      "cc_phone_model",
      normalizedKey
    );


    /*
     * Shopify line-item property.
     */

    propertyInput.value =
      readableName;


    /*
     * Visible selector values.
     */

    brandValue.textContent =
      selectedBrand;


    modelValue.textContent =
      readableName;


    /*
     * Show model selector.
     */

    modelGroup.hidden =
      false;


    /*
     * Remove validation error.
     */

    error.hidden =
      true;


    /*
     * Preview bridge.
     */

    previewBridge.value =
      readableName;

    previewBridge.checked =
      true;


    /*
     * Trigger existing preview JS.
     */

    previewBridge.dispatchEvent(
      new Event("change", {
        bubbles: true
      })
    );


    /*
     * Close dropdowns.
     */

    closeDropdowns();


    /*
     * Clear searches.
     */

    brandSearch.value =
      "";

    modelSearch.value =
      "";

  }


  /* ---------------------------------------------------------
     SHOP BY PHONE AUTO-SELECTION
  --------------------------------------------------------- */

  const storedModel =
    sessionStorage.getItem(
      "cc_phone_model"
    );


  if (
    storedModel
  ) {

    const normalizedStoredModel =
      normalizeModel(
        storedModel
      );


    const storedModelData =
      models.find(
        model =>
          model.key ===
          normalizedStoredModel
      );


    if (
      storedModelData &&
      !outOfStockModels.includes(
        normalizedStoredModel
      )
    ) {

      selectedBrand =
        storedModelData.brand;


      selectedModel =
        normalizedStoredModel;


      brandValue.textContent =
        storedModelData.brand;


      modelValue.textContent =
        storedModelData.name;


      modelGroup.hidden =
        false;


      propertyInput.value =
        storedModelData.name;


      previewBridge.value =
        storedModelData.name;


      previewBridge.checked =
        true;


      /*
       * Trigger existing preview JS.
       */

      previewBridge.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );

    }

  }


  /* ---------------------------------------------------------
     BRAND DROPDOWN
  --------------------------------------------------------- */

  brandButton.addEventListener(
    "click",
    event => {

      event.stopPropagation();


      const isOpen =
        !brandDropdown.hidden;


      closeDropdowns();


      if (!isOpen) {

        brandDropdown.hidden =
          false;


        brandButton.setAttribute(
          "aria-expanded",
          "true"
        );


        renderBrands();


        setTimeout(() => {

          brandSearch.focus();

        }, 50);

      }

    }
  );


  /* ---------------------------------------------------------
     MODEL DROPDOWN
  --------------------------------------------------------- */

  modelButton.addEventListener(
    "click",
    event => {

      event.stopPropagation();


      if (!selectedBrand) {

        return;

      }


      const isOpen =
        !modelDropdown.hidden;


      closeDropdowns();


      if (!isOpen) {

        modelDropdown.hidden =
          false;


        modelButton.setAttribute(
          "aria-expanded",
          "true"
        );


        renderModels();


        setTimeout(() => {

          modelSearch.focus();

        }, 50);

      }

    }
  );


  /* ---------------------------------------------------------
     BRAND SEARCH
  --------------------------------------------------------- */

  brandSearch.addEventListener(
    "input",
    () => {

      renderBrands(
        brandSearch.value
      );

    }
  );


  /* ---------------------------------------------------------
     MODEL SEARCH
  --------------------------------------------------------- */

  modelSearch.addEventListener(
    "input",
    () => {

      renderModels(
        modelSearch.value
      );

    }
  );


  /* ---------------------------------------------------------
     CLOSE WHEN CLICKING OUTSIDE
  --------------------------------------------------------- */

  document.addEventListener(
    "click",
    event => {

      if (
        !wrapper.contains(
          event.target
        )
      ) {

        closeDropdowns();

      }

    }
  );


  /* ---------------------------------------------------------
     MANDATORY PHONE MODEL VALIDATION
  --------------------------------------------------------- */

  window.CCValidatePhoneModel =
    function (event) {

      const currentModel =
        sessionStorage.getItem(
          "cc_phone_model"
        );


      const normalizedModel =
        normalizeModel(
          currentModel
        );


      if (
        !currentModel ||
        !Object.prototype.hasOwnProperty.call(
          window.phoneFrames,
          normalizedModel
        ) ||
        outOfStockModels.includes(
          normalizedModel
        )
      ) {

        if (event) {

          event.preventDefault();

        }


        error.hidden =
          false;


        /*
         * If a brand hasn't been selected,
         * focus the brand selector.
         */

        if (!selectedBrand) {

          brandButton.focus();

        } else {

          modelButton.focus();

        }


        return false;

      }


      return true;

    };


  /* ---------------------------------------------------------
     BACKUP FORM VALIDATION
  --------------------------------------------------------- */

  form.addEventListener(
    "submit",
    window.CCValidatePhoneModel,
    true
  );


    /* ---------------------------------------------------------
     STYLES
  --------------------------------------------------------- */

  const style =
    document.createElement(
      "style"
    );


  style.textContent = `

    .cc-phone-selector {
      margin-bottom: 14px;
      position: relative;
      z-index: 20;
    }


    .cc-phone-selector__group {
      margin-bottom: 10px;
      position: relative;
    }


    .cc-phone-selector__label {
      display: block;
      margin-bottom: 5px;
      font-size: 13px;
      font-weight: 500;
    }


    .cc-phone-selector__label span {
      color: #d00;
    }


    .cc-phone-selector__button {
      width: 100%;
      min-height: 44px;
      padding: 10px 12px;
      border: 1px solid rgba(0,0,0,.18);
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      text-align: left;
      font: inherit;
      font-size: 14px;
      box-sizing: border-box;
    }


    .cc-phone-selector__value {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }


    .cc-phone-selector__arrow {
      flex-shrink: 0;
      margin-left: 8px;
      font-size: 13px;
    }


    .cc-phone-selector__dropdown {
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      margin-top: 3px;
      background: #fff;
      border: 1px solid rgba(0,0,0,.15);
      box-shadow: 0 5px 16px rgba(0,0,0,.10);
      z-index: 100;
    }


    .cc-phone-selector__search {
      width: calc(100% - 16px);
      margin: 8px;
      padding: 8px 9px;
      border: 1px solid rgba(0,0,0,.18);
      font: inherit;
      font-size: 13px;
      box-sizing: border-box;
    }


    .cc-phone-selector__list {
      max-height: 240px;
      overflow-y: auto;
    }


    .cc-phone-selector__item {
      width: 100%;
      border: 0;
      border-bottom: 1px solid rgba(0,0,0,.05);
      background: #fff;
      padding: 9px 12px;
      cursor: pointer;
      text-align: left;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
      font: inherit;
      font-size: 13px;
      box-sizing: border-box;
    }


    .cc-phone-selector__item:hover {
      background: #f5f5f5;
    }


    .cc-phone-selector__item-brand {
      font-size: 12px;
      white-space: nowrap;
    }


    .cc-phone-selector__item--oos {
      cursor: not-allowed;
      background: #f7f7f7;
    }


    .cc-phone-selector__item--oos
    .cc-phone-selector__item-name {
      opacity: .65;
    }


    .cc-phone-selector__item--oos
    .cc-phone-selector__item-brand {
      opacity: 1;
      font-size: 12px;
    }


    .cc-phone-selector__item--oos:hover {
      background: #f7f7f7;
    }


    .cc-phone-selector__empty {
      padding: 11px 12px;
      opacity: .6;
      font-size: 13px;
    }


    .cc-phone-selector__error {
      margin-top: 5px;
      color: #d00;
      font-size: 12px;
    }

  `;


  document.head.appendChild(
    style
  );


  /* ---------------------------------------------------------
     INITIAL RENDER
  --------------------------------------------------------- */

  renderBrands();


});